"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var React = require("react");
var formik_1 = require("formik");
require("../OTP_Management/otp_management_styles.scss");
var system_configuration_api_calls_1 = require("./system_configuration_api_calls");
var material_1 = require("@mui/material");
var Edit_1 = require("@mui/icons-material/Edit");
var array_helpers_1 = require("../../../utils/array_helpers");
var menu_constants_1 = require("../../../menuList/menu_constants");
var text_filed_component_1 = require("../../../common/text_filed/text_filed_component");
var button_component_1 = require("../../../common/buttons/button_component");
var SystemConfiguration = function () {
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.SYSTEM_CONFIGURATION);
    var _a = React.useState(), initialValues = _a[0], setInitialValues = _a[1];
    var _b = React.useState({}), editingValues = _b[0], setEditingValues = _b[1];
    var clearEditingValue = function (key) {
        setEditingValues(function (prev) { var next = __assign({}, prev); delete next[key]; return next; });
    };
    var formSubmitHandler = function (values, setFieldValue, key) {
        var _a;
        var editValue = (_a = editingValues[key]) !== null && _a !== void 0 ? _a : values.temporaryValue;
        var payload = {
            id: Number(values.id),
            value: editValue,
        };
        (0, system_configuration_api_calls_1.submitTimesGaps)(payload)
            .then(function (response) {
            if (response.status === 200) {
                setFieldValue("".concat(key, ".svalue"), editValue);
                setFieldValue("".concat(key, ".isEdit"), false);
                clearEditingValue(key);
            }
        });
    };
    var fetchOndemandFields = function (isMounted) {
        var privateListAccess = features[menu_constants_1.FEATURE_CONSTANTS.SYSTEM_PRIVATE_CONFIG] ? 1 : 0;
        var payload = {
            show_all: privateListAccess
        };
        (0, system_configuration_api_calls_1.fetchOndemandTimeGaps)(payload)
            .then(function (response) {
            if (!isMounted)
                return;
            var updatedInitialvalues = {};
            response.forEach(function (fields, index) {
                var _a;
                var trimmedKey = (_a = fields === null || fields === void 0 ? void 0 : fields.description) === null || _a === void 0 ? void 0 : _a.replace(/ /g, "");
                fields['isEdit'] = false;
                fields['temporaryValue'] = fields.svalue;
                updatedInitialvalues[trimmedKey] = fields;
            });
            setInitialValues(updatedInitialvalues);
        })
            .catch(function (err) {
            if (isMounted) {
                console.log(err);
            }
        });
    };
    React.useEffect(function () {
        var isMounted = true;
        fetchOndemandFields(isMounted);
        return function () {
            isMounted = false;
        };
    }, []);
    return (React.createElement(formik_1.Formik, { initialValues: __assign({}, initialValues), validateOnBlur: false, enableReinitialize: true, onSubmit: function () { } }, function (_a) {
        var errors = _a.errors, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched;
        return (React.createElement(formik_1.Form, { id: "myForm", className: "input-fileds-wrapper system-config-wrapper" },
            React.createElement("div", { className: "tool-bar-wrapper border-bottom no-filter-toolbar" },
                React.createElement("div", { className: "page-heaidng heading-return-wrapper" },
                    React.createElement("h2", null, "System Configurations"))),
            React.createElement(Grid_1.default, { container: true, className: 'form-filed-wrapper' },
                React.createElement(Grid_1.default, { item: true, container: true, xs: 12, columnSpacing: 3 },
                    React.createElement(Grid_1.default, { item: true, xs: 8 },
                        React.createElement("p", { className: 'config-label' }, "Description")),
                    React.createElement(Grid_1.default, { item: true, xs: 4 },
                        React.createElement("p", { className: 'config-label' }, "Value"))),
                React.createElement(formik_1.FieldArray, { name: "applications" }, function (_a) {
                    var remove = _a.remove;
                    return (Object.entries(values).map(function (_a) {
                        var _b, _c, _d, _e, _f, _g, _h;
                        var key = _a[0];
                        return (React.createElement(Grid_1.default, { item: true, container: true, xs: 12, columnSpacing: 3, key: key, className: "config-wrapper ".concat(((_b = values[key]) === null || _b === void 0 ? void 0 : _b.isEdit) ? 'config-wrapper--editing' : '') },
                            React.createElement(Grid_1.default, { item: true, xs: 8, style: { display: 'flex', alignItems: 'center' } },
                                React.createElement("h2", { className: "label-heading heading" }, (_c = values[key]) === null || _c === void 0 ? void 0 : _c.description)),
                            React.createElement(Grid_1.default, { item: true, container: true, xs: 4, style: { alignItems: 'center' } },
                                React.createElement(Grid_1.default, { item: true, xs: 10 },
                                    React.createElement("div", { className: "config-value-display" }, (_d = values[key]) === null || _d === void 0 ? void 0 : _d.svalue)),
                                React.createElement(Grid_1.default, { item: true, xs: 2, style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } }, !((_e = values[key]) === null || _e === void 0 ? void 0 : _e.isEdit) &&
                                    React.createElement(material_1.IconButton, { className: "icon-btn", onClick: function () {
                                            setEditingValues(function (prev) {
                                                var _a;
                                                var _b;
                                                return (__assign(__assign({}, prev), (_a = {}, _a[key] = (_b = values[key]) === null || _b === void 0 ? void 0 : _b.svalue, _a)));
                                            });
                                            setFieldValue("".concat(key, ".isEdit"), true);
                                        } },
                                        React.createElement(Edit_1.default, { sx: { fontSize: '27px' } })))),
                            React.createElement(Grid_1.default, { item: true, xs: 12, className: "config-accordion ".concat(((_f = values[key]) === null || _f === void 0 ? void 0 : _f.isEdit) ? 'config-accordion--open' : '') },
                                React.createElement(Grid_1.default, { container: true, className: "config-accordion__inner" },
                                    React.createElement(Grid_1.default, { item: true, md: 8, className: 'textfield-wrapper' },
                                        React.createElement(text_filed_component_1.default, { name: key, value: (_g = editingValues[key]) !== null && _g !== void 0 ? _g : (_h = values[key]) === null || _h === void 0 ? void 0 : _h.svalue, onChange: function (val) {
                                                setEditingValues(function (prev) {
                                                    var _a;
                                                    return (__assign(__assign({}, prev), (_a = {}, _a[key] = val, _a)));
                                                });
                                            }, isDisabled: false, required: true }),
                                        errors[values[key]] && touched[values[key]] ? (React.createElement("div", { className: "error" }, errors[values[key]])) : null),
                                    React.createElement(Grid_1.default, { item: true, xs: 12, md: 4, className: "config-accordion__actions" },
                                        React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: function () {
                                                clearEditingValue(key);
                                                setFieldValue("".concat(key, ".isEdit"), false);
                                            } }),
                                        React.createElement(button_component_1.default, { type: "Save Changes", buttonName: "Confirm", color: "yellow", onClickHandler: function () { return formSubmitHandler(values[key], setFieldValue, key); } }))))));
                    }));
                }))));
    }));
};
exports.default = SystemConfiguration;
